import type { TFunction } from 'react-i18next';
import { ScenarioSettingsLanguageVals } from 'app/components/ScenarioEditorPage/ScenarioSettingsDialog/types.ts';
import type { I18nCoreNs } from '@/i18n/dictionaries/interfaces.ts';

interface LanguageOption {
  value: string;
  labelKey: string;
}

const languageOptions: LanguageOption[] = [
  { value: ScenarioSettingsLanguageVals.Norwegian, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.norwegian) },
  { value: ScenarioSettingsLanguageVals.English, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.englishus) },
  { value: ScenarioSettingsLanguageVals.EnglishUk, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.englishuk) },
  { value: ScenarioSettingsLanguageVals.German, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.german) },
  { value: ScenarioSettingsLanguageVals.Dutch, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.dutch) },
  { value: ScenarioSettingsLanguageVals.French, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.french) },
  { value: ScenarioSettingsLanguageVals.Italian, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.italian) },
  { value: ScenarioSettingsLanguageVals.Danish, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.danish) },
  { value: ScenarioSettingsLanguageVals.Swedish, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.swedish) },
  { value: ScenarioSettingsLanguageVals.Icelandic, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.icelandic) },
  { value: ScenarioSettingsLanguageVals.EnglishAustralia, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.englishAustralia) },
  { value: ScenarioSettingsLanguageVals.SpanishSpain, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.spanishSpain) },
  { value: ScenarioSettingsLanguageVals.SpanishMexico, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.spanishMexico) },
  { value: ScenarioSettingsLanguageVals.SpanishUS, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.spanishUs) },
  { value: ScenarioSettingsLanguageVals.ArabicUae, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.arabicUae) },
  { value: ScenarioSettingsLanguageVals.Hindi, labelKey: nameof.full<I18nCoreNs>((l) => l.languagePicker.hindi) }
];

/**
 * Converts a language code to a user-friendly display name using i18n translations.
 * Falls back to the raw language code if no translation is found.
 * 
 * @param languageCode - The language code (e.g., 'en-US', 'nb-NO')
 * @param translateFn - The i18n translation function for Core namespace
 * @returns The translated language name or the original code if not found
 */
export const getLanguageDisplayName = (
  languageCode: string | undefined | null,
  translateFn: TFunction
): string => {
  if (!languageCode) return 'N/A';
  
  const option = languageOptions.find(opt => opt.value === languageCode);
  return option ? translateFn(option.labelKey) : languageCode;
};

export default {
  getLanguageDisplayName
};
